import _Model from "./_Model";
import { rangeProductType } from "../constants";

export default class RangeInfo extends _Model {
  constructor(json) {
    super(json);
    this.rangeId = RangeInfo.getOrDefault(json, 'rangeId', '');
    this.rangeName = RangeInfo.getOrDefault(json, 'rangeName', '');
    this.productType = RangeInfo.getMappedOrDefault(json, 'productType', rangeProductType.unknown, v => (v || rangeProductType.unknown).toLowerCase());
    this.maxBlockIOModules = RangeInfo.getMappedOrDefault(json, 'maxBlockIOModules', 0, v => parseInt(v));
    this.maxTotalIOModules = RangeInfo.getMappedOrDefault(json, 'maxTotalIOModules', 0, v => parseInt(v));
    this.maxIOModuleBlocks = RangeInfo.getMappedOrDefault(json, 'maxIOModuleBlocks', 0, v => parseInt(v));
    this.maxComModules = RangeInfo.getMappedOrDefault(json, 'maxComModules', 0, v => parseInt(v));
    this.maxTotalIOIslands = RangeInfo.getMappedOrDefault(json, 'maxTotalIOIslands', 0, v => parseInt(v));
    this.rangeIOModules = RangeInfo.getOrDefault(json, 'rangeIOModules', []);
    this.canExportToMachineExpert = RangeInfo.getMappedOrDefault(json, 'canExportToMachineExpert', false, v => Boolean(v));
    this.ioModulesQuestionCategory = RangeInfo.getOrDefault(json, 'ioModulesQuestionCategory', '');
    this.needRack = RangeInfo.getMappedOrDefault(json, 'needRack', false, v => Boolean(v));
    this.extensionRackRange = RangeInfo.getOrDefault(json, 'extensionRackRange', '');
  }

  /**
   * Returns true if the range allows to show the power supply buses : if we are in TM5 or TM7 range.
   */
  canShowPowerSupplyBuses() {
    return this.rangeId && (this.rangeId === '61070' || this.rangeId === '61069');
  }

  get rangeIOModule() {
    return this.rangeIOModules.find((v, i) => i === 0);
  }

}
